import { isNotUndefined } from 'infrastructure/functions';

import {
  genThresholdText,
  additionalFollowUpText,
  croOrDncText,
  needEscalateText,
  uniqueDaysTextWithType,
  readingInTargetRangeText,
} from '../helpers';

import type { TMaGlucoseGreenDataOptional } from '../../types';

export const glucose = (data: TMaGlucoseGreenDataOptional) => {
  let text = '';

  const thresholdTextBp = genThresholdText(
    'blood glucose',
    data.glucoseAvg,
    data.glucoseAvg30days,
    data.glucoseAvg90days,
  );
  if (thresholdTextBp.trim()) text += `\n${thresholdTextBp}`;

  const inTargetRangeText = readingInTargetRangeText(
    data.glucoseWithinRange,
    data.glucoseWithinRangeComment,
  );
  if (inTargetRangeText.trim()) text += `\n${inTargetRangeText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysTextWithType('glucose', data.uniqueDays);
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
